
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { requestTypes } from "@/constants/documentTypes"

interface RequestFieldsProps {
  requestType?: string
  onChange: (field: string, value: string) => void
}

export function RequestFields({ requestType, onChange }: RequestFieldsProps) {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
        Tipo de Requerimento
      </Label>
      <Select
        value={requestType}
        onValueChange={(value) => onChange("requestType", value)}
        required
      >
        <SelectTrigger className="w-full border-gray-200 focus:ring-primary/20">
          <SelectValue placeholder="Selecione o tipo de requerimento" />
        </SelectTrigger>
        <SelectContent className="max-h-[200px] overflow-y-auto">
          {requestTypes.map((type) => (
            <SelectItem key={type} value={type}>
              {type}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
